import React, { useEffect, useState } from "react"
import { Alert, Box, ModalClose } from "@mui/joy"
import { useTranslation } from 'react-i18next'
import { BreadCrumb, Button, DetailTitle, InfoHeader, Text } from "src/mtska-frontend-app-component"
import { ImporterFileMappingConstants } from "../../Import/components"
import { useDataProvider } from "src/mtska-frontend-data-provider"

const Preverify = (params) => {
    const { t } = useTranslation();
    const [actionInvoked, setActionInvoked] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [forwardDisabled, setForwardDisabled] = useState(false);
    const [backDisabled, setBackDisabled] = useState(true);
    const [actionLabel, setActionLabel] = useState(t("Next"));

    const { uploadAndDownload, errorMessage: dataProviderErrorMessage } = useDataProvider('audiences/audiencelead/verifyLeads', true);

    useEffect(() => {
        if (!dataProviderErrorMessage) return;
        setErrorMessage(dataProviderErrorMessage)
    }, [dataProviderErrorMessage])

    const handleNext = () => {
        setTimeout(() => {
            setActionInvoked(1);
        }, 2000);
    };

    return <>
        <Box className="drawer-section-header">
            <ModalClose />

            <DetailTitle title={t('Preverifica')} icon="faFile" />

            <Box display="flex" flexDirection="row" justifyContent="end" gap={1} flexGrow={1}>
                <Button
                    label={'Back'}
                    onClick={() => setActionInvoked(-1)}
                    disabled={backDisabled}
                />
                <Button
                    label={actionLabel}
                    onClick={handleNext}
                    disabled={forwardDisabled}
                />
            </Box>
        </Box>

        <BreadCrumb />
        {errorMessage && (
            <Alert color="danger">{errorMessage}</Alert>
        )}
        <Box className="drawer-section-content">
            <InfoHeader
                view="wizard"
                title={t('Controllo esistenza lead')}
                subtitle={t('Upload a file to the system')}
            />
            <ImporterFileMappingConstants
                {...params}
                externalSetForwardDisabled={setForwardDisabled}
                externalSetBackDisabled={setBackDisabled}
                externalSetActionInvoked={setActionInvoked}
                externalSetActionLabel={setActionLabel}
                externalSetErrorMessage={setErrorMessage}
                actionInvoked={actionInvoked}

                externalFinalSave={uploadAndDownload}
                externalFinalSaveThen={() => {}}
                externalFinalMessage={t('Verifica effettuata con successo')}
            />
        </Box>
    </>
}

export default Preverify;